<template>
  <div class="NoMfaSetting">
    <account-header />
    <v-divider class="NoMfaSetting_divider" />
    <h3 class="NoMfaSetting_title">
      多要素認証設定を解除すると、ログイン時に多要素認証を確認しなくなります。
    </h3>
    <section class="NoMfaSetting_content">
      <p>
        複数のウェブサイトで同じパスワードを使用している場合など、別サイトのアカウント情報が第三者に知られた場合、当サイトのアカウントにも影響を及ぼす可能性があります。<br />
        多要素認証をリセットするとセキュリティリスクが高まります。
      </p>
    </section>
    <div class="NoMfaSetting_action">
      <v-btn
        class="NoMfaSetting_btn-submit"
        :disabled="submitDisabled"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        多要素認証設定を解除
      </v-btn>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services/auth.service';
import AccountHeader from '../AccountHeader.vue';

export default {
  name: 'NoMfaSetting',
  components: {
    AccountHeader,
  },
  data() {
    return {
      submitLoading: false,
      submitDisabled: false,
    };
  },
  mounted() {},
  methods: {
    async handleSubmit() {
      try {
        this.submitLoading = true;
        await authService.setMFA('NOMFA');
        this.$router.push({ name: 'account-mfa' });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.NoMfaSetting {
  overflow: auto;
  height: 100%;

  &_content {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    margin-top: 10px;
  }

  &_title {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    margin-top: 15px;
  }

  &_divider {
    margin-top: 16px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_gap-header {
    height: 26px;
  }
  &_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    &-delete {
      padding: 9px 0;
    }
    padding: 15px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-submit {
      &.theme--light.v-btn.v-btn--has-bg {
        height: 36px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
      }
      &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
        background-color: #f3f3f3 !important;
        box-shadow: none;
        color: #ccc !important;
      }
    }

    &-delete {
      .icon-trash {
        font-size: 16px;
        color: #989898;
      }
    }
  }
}
</style>
